"use client";

import { useRef, useEffect, MutableRefObject } from "react";
import { useWindowScroll } from "react-use";
import { useAtom } from "jotai";
import { displayTopherState } from "../components/Navbar";

export function useEnableTopherDisplay(): [MutableRefObject<any>, boolean] {
  const divRef = useRef<HTMLDivElement>(null);
  const [_, setDisplayTopher] = useAtom(displayTopherState);
  useWindowScroll();

  const display =
    (divRef?.current?.getBoundingClientRect()?.top ?? Infinity) < 40;

  useEffect(() => {
    setDisplayTopher(display);
  }, [display]);

  return [divRef, display];
}

export function EnableTopherDisplayWhenScrolledPast() {
  const [divRef] = useEnableTopherDisplay();
  return <div ref={divRef} />;
}
